<template>
    <div>
        <q-score-card key="QScoreCardPending" title="Pending" api-endpoint="pending" drill-down-label="Policy Breakdown" :drill-down-route="drillDownRoute ? drillDownRoute : 'Pending Policies'" card-style="production" :agent-code="agentCode" :filters="filters" :hide-goal="true" format="Currency" :show-drill-down-on-personal="true" :hide-historical-data="true">
            Note: Policies submitted but have outstanding requirements before being placed at the carrier - updated daily. Pending policies are supplied by most carriers daily but not all. Please refer to <router-link to="/new_business/carrier_portal" class="font-weight-bold">carrier portal page</router-link> to see the carriers included in this dashboard.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardPending",
    props: ["agentCode", "filters", "defaultGoal", "drillDownRoute"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {

    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
